import React from "react";
import { useDynamicText } from "../../Hooks/useDynamicText";
import { imageURL2 } from "../../images";
// import EngagementDiscover from "./EngagementDiscover";
import {
  engagementFAQ,
  engagementGridHomeProduct,
  engagementGridHomeRongProduct,
  engagementReviewProduct,
  engagementRingEleganceProduct,
} from "../../constants/utils";
import GlobalReview from "../common/global-review";
import EngagementFAQ from "./EngagementFAQ";
import EngagementNoDealBreaker from "./EngagementNoDEalBreaker";
import EngagementRingElegance from "./EngagementRingElegance";
import EngagementGridHome from "./EngagmentGrid";
import EngagementGridHomeRong from "./EngagmentGridMetal";
import EngagementHero from "./EngagmentHero";

const Engagement = () => {
  const text = useDynamicText();
  return (
    <>
      <EngagementHero imageURL2={imageURL2} text={text} />
      <EngagementGridHome
        Products={engagementGridHomeProduct(imageURL2)}
        title={text?.text_16}
      />
      {/* <EngagementReview
        Reviews={engagementReviewProduct(imageURL2)}
        title="OUR CUSTOMERS LOVE US"
      /> */}
      <GlobalReview
        Reviews={engagementReviewProduct(imageURL2)}
        title="OUR CUSTOMERS LOVE US"
      />
      <EngagementRingElegance
        Products={engagementRingEleganceProduct(imageURL2)}
        title={text?.text_17}
      />
      <EngagementGridHomeRong
        Products={engagementGridHomeRongProduct(imageURL2)}
        lg={4}
        title={text?.text_14}
      />
      <EngagementNoDealBreaker />
      <EngagementFAQ faqs={engagementFAQ()} />
    </>
  );
};

export default Engagement;
